module.exports = __webpack_public_path__ + "img/fondo-login-min.8a4d6f65.png";